import { StyledSkeleton } from "./Skeleton.styles";

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: string;
  height?: string;
  rounded?: boolean;
}

export const Skeleton = ({
  width,
  height,
  rounded,
  ...props
}: SkeletonProps) => {
  return (
    <StyledSkeleton
      width={width}
      height={height}
      $rounded={rounded}
      {...props}
    />
  );
};
